// extracted by mini-css-extract-plugin
export var clutchIcon = "review-module--clutchIcon--4fa3d";
export var clutchLink = "review-module--clutchLink--388cb";
export var fadeInAnimation = "review-module--fadeInAnimation--9715c";
export var feedbackWrapper = "review-module--feedbackWrapper--37320";
export var header = "review-module--header--28cd7";
export var hint = "review-module--hint--75d9c";
export var link = "review-module--link--81744";
export var linkedinIcon = "review-module--linkedinIcon--3fb7a";
export var location = "review-module--location--1f0a3";
export var locationImg = "review-module--locationImg--63d40";
export var name = "review-module--name--91603";
export var page = "review-module--page--5a407";
export var personalData = "review-module--personalData--9c34e";
export var personalDataWrapper = "review-module--personalDataWrapper--16806";
export var photo = "review-module--photo--0f11d";
export var position = "review-module--position--3c291";
export var review = "review-module--review--2b7f3";
export var text = "review-module--text--cb804";
export var title = "review-module--title--56fd6";